<script>
export default {
  name: 'BaseForm',

  functional: true,

  props: {
    novalidate: {
      type: Boolean,
      default: true
    }
  },

  render (createElement, { props, data, children }) {
    return createElement('form', Object.assign({}, data, { attrs: { novalidate: props.novalidate } }), children)
  }
}
</script>
